import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "navbar-nav" }
const _hoisted_2 = { class: "nav-item dropend" }
const _hoisted_3 = {
  class: "d-flex align-items-center nav-link py-0 justify-content-between align-items-center pe-3 text-nowrap btn",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  "data-bs-offset": "[0,10]"
}
const _hoisted_4 = { class: "ms-5 d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box" }, null, -1)
const _hoisted_6 = { class: "ms-2 d-block py-2" }
const _hoisted_7 = { class: "dropdown-header font-semibold" }
const _hoisted_8 = { class: "dropdown-item d-flex align-items-center overflow-y-scroll" }
const _hoisted_9 = { class: "me-5 col-8" }
const _hoisted_10 = { class: "ms-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear-fill" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "dropdown-divider my-3"
}
const _hoisted_14 = {
  key: 1,
  class: "dropdown-header font-semibold"
}
const _hoisted_15 = { class: "list-spaces overflow-y-auto" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ms-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear-fill" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider my-3" }, null, -1)
const _hoisted_22 = { class: "px-3" }
const _hoisted_23 = {
  class: "navbar-nav mt-3",
  id: "navbar-vertical-default-menu"
}
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)
const _hoisted_27 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-view-stacked" }, null, -1)
const _hoisted_31 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_32 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-view-stacked" }, null, -1)
const _hoisted_34 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left-quote" }, null, -1)
const _hoisted_38 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_39 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left-quote" }, null, -1)
const _hoisted_41 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_42 = { class: "nav-item" }
const _hoisted_43 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-megaphone" }, null, -1)
const _hoisted_45 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_46 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-megaphone" }, null, -1)
const _hoisted_48 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_49 = { class: "nav-item d-none" }
const _hoisted_50 = {
  href: "#!",
  class: "nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap"
}
const _hoisted_51 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-binoculars" }, null, -1)
const _hoisted_53 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_54 = { class: "nav-item" }
const _hoisted_55 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-sliders" }, null, -1)
const _hoisted_57 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_58 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-sliders" }, null, -1)
const _hoisted_60 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_61 = { class: "nav-item" }
const _hoisted_62 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell" }, null, -1)
const _hoisted_64 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_65 = { class: "mt-1 nav-item my-2" }
const _hoisted_66 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square-dotted" }, null, -1)
const _hoisted_68 = { class: "d-inline-block py-2 ms-2" }
const _hoisted_69 = { class: "border-top navbar-nav section-nav" }
const _hoisted_70 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up d-none" }, null, -1)
const _hoisted_72 = {
  style: {"font-style":"italic","font-size":"small"},
  class: "d-inline-block py-2 ms-0 font-light"
}
const _hoisted_73 = { class: "ms-5 d-flex justify-content-between align-items-center" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up d-none" }, null, -1)
const _hoisted_75 = {
  style: {"font-style":"italic","font-size":"small"},
  class: "d-inline-block py-2 ms-0 font-light"
}
const _hoisted_76 = {
  key: 0,
  class: "mt-auto d-flex flex-column gap-2"
}
const _hoisted_77 = {
  key: 0,
  class: "nav-link py-2 d-flex justify-content-between align-items-center pe-3 text-nowrap"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wallet2" }, null, -1)
const _hoisted_79 = { class: "ms-2" }
const _hoisted_80 = {
  key: 1,
  class: "px-4 text-xxs text-muted"
}
const _hoisted_81 = { class: "px-4" }
const _hoisted_82 = { class: "d-flex justify-content-between text-xs" }
const _hoisted_83 = { class: "font-bold" }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = {
  class: "progress",
  style: {"height":"0.25rem"}
}
const _hoisted_87 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('bg-success'),
  role: "progressbar",
  style: 'width: 100%',
  "aria-valuenow": 100,
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_88 = ["aria-valuenow"]
const _hoisted_89 = {
  key: 2,
  class: "progress-bar",
  role: "progressbar",
  style: {"width":"0%"},
  "aria-valuenow": 0,
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_90 = { class: "px-4" }
const _hoisted_91 = { class: "d-flex justify-content-between text-xs" }
const _hoisted_92 = { class: "font-bold" }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 2 }
const _hoisted_95 = {
  class: "progress",
  style: {"height":"0.25rem"}
}
const _hoisted_96 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('bg-success'),
  role: "progressbar",
  style: 'width: 100%',
  "aria-valuenow": 100,
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_97 = ["aria-valuenow"]
const _hoisted_98 = {
  key: 2,
  class: "progress-bar",
  role: "progressbar",
  style: {"width":"0%"},
  "aria-valuenow": 0,
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_99 = { class: "px-4" }
const _hoisted_100 = { class: "d-flex justify-content-between text-xs" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Spaces", -1)
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = {
  class: "progress",
  style: {"height":"0.25rem"}
}
const _hoisted_105 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('bg-success'),
  role: "progressbar",
  style: 'width: 100%',
  "aria-valuenow": 100,
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_106 = ["aria-valuenow"]
const _hoisted_107 = {
  key: 2,
  class: "progress-bar",
  role: "progressbar",
  style: {"width":"0%"},
  "aria-valuenow": 0,
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_108 = {
  key: 2,
  class: "px-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DropdownComponent = _resolveComponent("DropdownComponent")!
  const _component_LoaderSpinnerComponent = _resolveComponent("LoaderSpinnerComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$store.state.space.name), 1)
          ])
        ]),
        _createVNode(_component_DropdownComponent, null, {
          content: _withCtx(() => [
            _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
								_ctx.$text('expressions', 'Switch_Space_Current_Title')
							)), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$store.state.space.name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.$permission.canGetSpace())
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
									name: _ctx.$config('RouteConfig', _ctx.$store.state.space.onboarding === 'completed'?'SpaceUpdateRouteName' :'OnboardingRouteName'),
									params: {
										organization_id: _ctx.$store.state.organization._id,
										space_id: _ctx.$store.state.space._id,
									},
								},
                      class: "a-icon p-1"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (
									_ctx.$permission.canListSpaceUsers(
										_ctx.$store.state.organization.role,
										_ctx.$store.state.space.role
									)
								)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: {
									name: _ctx.$config('RouteConfig', 'SpaceRolesRouteName'),
									params: {
										organization_id: _ctx.$store.state.organization._id,
										space_id: _ctx.$store.state.space._id,
									},
								},
                      class: "a-icon p-1 me-n1"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.$store.state.spaces.length > 1)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.$store.state.spaces.length > 1)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
								_ctx.$text('expressions', 'Switch_Space_Change_Title')
							)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.spaces.filter(
								(space) => space._id !== _ctx.$store.state.space._id
							), (space, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "dropdown-item d-flex align-items-center overflow-y-scroll",
                  key: index
                }, [
                  _createElementVNode("a", {
                    class: "col-8",
                    onClick: ($event: any) => (_ctx.switchSpace(space._id))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(space.name), 1)
                  ], 8, _hoisted_16),
                  _createElementVNode("div", _hoisted_17, [
                    (
										_ctx.$permission.canGetSpace(
											_ctx.$store.state.organization.role,
											space.role
										)
									)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
										name: _ctx.$config('RouteConfig', _ctx.$store.state.space.onboarding === 'completed'?'SpaceUpdateRouteName' :'OnboardingRouteName'),
										params: {
											organization_id: _ctx.$store.state.organization._id,
											space_id: space._id,
										},
									},
                          class: "a-icon p-1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (
										_ctx.$permission.canListSpaceUsers(
											_ctx.$store.state.organization.role,
											space.role
										)
									)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: {
										name: _ctx.$config('RouteConfig', 'SpaceRolesRouteName'),
										params: {
											organization_id: _ctx.$store.state.organization._id,
											space_id: space._id,
										},
									},
                          class: "a-icon p-1 me-n1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.$permission.canCreateSpace())
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: "btn btn-sm text-white btn-brand w-full",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (
									_ctx.$limitation.organizationSpacesLimitReached()
										? _ctx.showPaymentModal()
										: _ctx.$router.push({
												name: _ctx.$config('RouteConfig', 'SpaceCreateRouteName'),
												params: {
													organization_id: _ctx.$store.state.organization._id,
												},
										  })
								)),
                      type: "button"
                    }, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
										_ctx.$text('actions', 'Create_A_Space')
									)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_23, [
      _createElementVNode("li", _hoisted_24, [
        _createVNode(_component_router_link, {
          to: {
					name: _ctx.$config('RouteConfig', 'ViewRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
						view_id: _ctx.$store.state.views.find((view) => {
							return (
								!view.organization_id &&
								!view.space_id &&
								view.title.toLowerCase() ===
									_ctx.$config('VueConfig', 'ViewNameOverview').toLowerCase()
							);
						})._id,
					},
				},
          class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName') &&
					_ctx.$store.state.view._id ===
						_ctx.$store.state.views.find((view) => {
							return (
								!view.organization_id &&
								!view.space_id &&
								view.title.toLowerCase() ===
									_ctx.$config('VueConfig', 'ViewNameOverview').toLowerCase()
							);
						})._id
						? 'active'
						: ''
				])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Overview'))), 1)
            ])
          ]),
          _: 1
        }, 8, ["to", "class"])
      ]),
      _createElementVNode("li", _hoisted_28, [
        (!_ctx.$limitation.contentsLimitedAccess())
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {
					name: _ctx.$config('RouteConfig', 'ContentsRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
					},
				},
              class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'ContentsRouteName')
						? 'active'
						: ''
				])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Contents'))), 1)
                ])
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap hover-pointer", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'ContentsRouteName')
						? 'active'
						: ''
				]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPaymentModal()))
            }, [
              _createElementVNode("span", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Contents'))), 1)
              ])
            ], 2))
      ]),
      _createElementVNode("li", _hoisted_35, [
        (!_ctx.$limitation.postsLimitedAccess())
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {
					name: _ctx.$config('RouteConfig', 'PostsRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
					},
				},
              class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'PostsRouteName')
						? 'active'
						: ''
				])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Social'))), 1)
                ])
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap hover-pointer", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'PostsRouteName')
						? 'active'
						: ''
				]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPaymentModal()))
            }, [
              _createElementVNode("span", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Social'))), 1)
              ])
            ], 2))
      ]),
      _createElementVNode("li", _hoisted_42, [
        (!_ctx.$limitation.insightsLimitedAccess())
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {
					name: _ctx.$config('RouteConfig', 'InsightsRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
					},
				},
              class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'InsightsRouteName')
						? 'active'
						: ''
				])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Insights'))), 1)
                ])
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap hover-pointer", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'InsightsRouteName')
						? 'active'
						: ''
				]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPaymentModal()))
            }, [
              _createElementVNode("span", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Insights'))), 1)
              ])
            ], 2))
      ]),
      _createElementVNode("li", _hoisted_49, [
        _createElementVNode("a", _hoisted_50, [
          _createElementVNode("span", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Predictive'))), 1)
          ])
        ])
      ]),
      _createElementVNode("li", _hoisted_54, [
        (_ctx.$store.state.brand !== null)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {
					name: _ctx.$config('RouteConfig', 'BrandUpdateRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
						brand_id: _ctx.$store.state.brand._id,
					},
				},
              class: "nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Parameters'))), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: {
					name: _ctx.$config('RouteConfig', 'BrandCreateRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
					},
				},
              class: "nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Parameters'))), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
      ]),
      _createElementVNode("li", _hoisted_61, [
        _createVNode(_component_router_link, {
          to: {
					name: _ctx.$config('RouteConfig', 'NotificationsUpdateRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id
					},
				},
          class: "nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Notifications'))), 1)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", _hoisted_65, [
        _createElementVNode("span", {
          class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap d-none", 
					_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName') &&
					_ctx.$store.state.view._id !==
						_ctx.$store.state.views.find((view) => {
							return (
								!view.organization_id &&
								!view.space_id &&
								view.title.toLowerCase() ===
									_ctx.$config('VueConfig', 'ViewNameOverview').toLowerCase()
							);
						})._id
						? 'active'
						: ''
				])
        }, [
          _createElementVNode("span", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
							_ctx.$text('expressions', 'VerticalNavBar_Global_Views')
						)), 1)
          ])
        ], 2),
        _createElementVNode("ul", _hoisted_69, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.views.filter((view) => {
						return (
							!view.organization_id &&
							!view.space_id &&
							view.title.toLowerCase() !==
								_ctx.$config('VueConfig', 'ViewNameOverview')
						);
					}), (view, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "nav-item"
            }, [
              (!_ctx.$limitation.viewsLimitedAccess())
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
							name: _ctx.$config('RouteConfig', 'ViewRouteName'),
							params: {
								organization_id: _ctx.$store.state.organization._id,
								space_id: _ctx.$store.state.space._id,
								view_id: view._id,
							},
						},
                    class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap", 
							_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName') &&
							_ctx.$store.state.view._id === view._id
								? 'active'
								: ''
						])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("span", _hoisted_72, _toDisplayString(view.title), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["nav-link py-0 d-flex justify-content-between align-items-center pe-3 text-nowrap hover-pointer", 
							_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName') &&
							_ctx.$store.state.view._id === view._id
								? 'active'
								: ''
						]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPaymentModal()))
                  }, [
                    _createElementVNode("span", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("span", _hoisted_75, _toDisplayString(view.title), 1)
                    ])
                  ], 2))
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.$permission.canGetOrganizationBilling(_ctx.$store.state.organization.role))
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          (_ctx.$store.state.organization.product)
            ? (_openBlock(), _createElementBlock("a", _hoisted_77, [
                _createElementVNode("span", null, [
                  _hoisted_78,
                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$store.state.organization.product.name), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.$store.state.organization.subscription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
					_ctx.$text('expressions', 'Usage_Reset').replace(
						'{time}',
						_ctx.$toolbox.friendlyCountdown(
							new Date(
								this.$store.state.organization.subscription.current_period_end *
									1000
							)
						)
					)
				)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.$beautify.eachWordFirstLetterUppercase(
						_ctx.$text('words', 'Contents')
					)), 1),
              _createElementVNode("div", null, [
                (_ctx.$store.state.metadata.contents === undefined)
                  ? (_openBlock(), _createBlock(_component_LoaderSpinnerComponent, {
                      key: 0,
                      class: "ms-2 mt-n1"
                    }))
                  : (
							_ctx.$store.state.organization.limitation &&
							_ctx.$store.state.organization.limitation.contents !== undefined
						)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.$store.state.metadata.contents + '/' +
						_ctx.$store.state.organization.limitation.contents), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.$store.state.metadata.contents), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              (
						_ctx.$store.state.profile.admin ||
						!_ctx.$store.state.organization.limitation ||
						!_ctx.$store.state.organization.limitation.contents
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87))
                : (
						_ctx.$store.state.organization.limitation &&
						_ctx.$store.state.organization.limitation.contents !== undefined
					)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(
						Number(
							(_ctx.$store.state.metadata.contents * 100) /
								_ctx.$store.state.organization.limitation.contents
						) > 80 &&
						Number(
							(_ctx.$store.state.metadata.contents * 100) /
								_ctx.$store.state.organization.limitation.contents
						) < 100
							? 'bg-warning'
							: Number(
									(_ctx.$store.state.metadata.contents * 100) /
										_ctx.$store.state.organization.limitation.contents
							  ) >= 100
							? 'bg-danger'
							: 'bg-success'
					),
                      role: "progressbar",
                      style: _normalizeStyle(
						'width:' +
						Number(
							(_ctx.$store.state.metadata.contents * 100) /
								_ctx.$store.state.organization.limitation.contents
						) +
						'%'
					),
                      "aria-valuenow": 
						Number(
							(_ctx.$store.state.metadata.contents * 100) /
								_ctx.$store.state.organization.limitation.contents
						)
					,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 14, _hoisted_88))
                  : (_openBlock(), _createElementBlock("div", _hoisted_89))
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$beautify.eachWordFirstLetterUppercase(
						_ctx.$text('words', 'Social_Posts')
					)), 1),
              _createElementVNode("div", null, [
                (_ctx.$store.state.metadata.posts === undefined)
                  ? (_openBlock(), _createBlock(_component_LoaderSpinnerComponent, {
                      key: 0,
                      class: "ms-2 mt-n1"
                    }))
                  : (
							_ctx.$store.state.organization.limitation &&
							_ctx.$store.state.organization.limitation.contents !== undefined
						)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(_ctx.$store.state.metadata.posts + '/' +
						_ctx.$store.state.organization.limitation.contents), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.$store.state.metadata.posts), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              (
						_ctx.$store.state.profile.admin ||
						!_ctx.$store.state.organization.limitation ||
						!_ctx.$store.state.organization.limitation.contents
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96))
                : (
						_ctx.$store.state.organization.limitation &&
						_ctx.$store.state.organization.limitation.contents !== undefined
					)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(
						Number(
							(_ctx.$store.state.metadata.posts * 100) /
								_ctx.$store.state.organization.limitation.contents
						) > 80 &&
						Number(
							(_ctx.$store.state.metadata.posts * 100) /
								_ctx.$store.state.organization.limitation.contents
						) < 100
							? 'bg-warning'
							: Number(
									(_ctx.$store.state.metadata.posts * 100) /
										_ctx.$store.state.organization.limitation.contents
							  ) >= 100
							? 'bg-danger'
							: 'bg-success'
					),
                      role: "progressbar",
                      style: _normalizeStyle(
						'width:' +
						Number(
							(_ctx.$store.state.metadata.posts * 100) /
								_ctx.$store.state.organization.limitation.contents
						) +
						'%'
					),
                      "aria-valuenow": 
						Number(
							(_ctx.$store.state.metadata.posts * 100) /
								_ctx.$store.state.organization.limitation.contents
						)
					,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 14, _hoisted_97))
                  : (_openBlock(), _createElementBlock("div", _hoisted_98))
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _hoisted_101,
              _createElementVNode("div", null, [
                (
							_ctx.$store.state.organization.limitation &&
							_ctx.$store.state.organization.limitation.organization_spaces !== undefined
						)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.$store.state.spaces.length + '/' +
						_ctx.$store.state.organization.limitation.organization_spaces), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_ctx.$store.state.spaces.length), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              (
						_ctx.$store.state.profile.admin ||
						!_ctx.$store.state.organization.limitation ||
						!_ctx.$store.state.organization.limitation.contents
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_105))
                : (
						_ctx.$store.state.organization.limitation &&
						_ctx.$store.state.organization.limitation.organization_spaces !== undefined
					)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["progress-bar", 
						Number(
							(_ctx.$store.state.spaces.length * 100) /
								_ctx.$store.state.organization.limitation.organization_spaces
						) > 80 &&
						Number(
							(_ctx.$store.state.spaces.length * 100) /
								_ctx.$store.state.organization.limitation.organization_spaces
						) < 100
							? 'bg-warning'
							: Number(
									(_ctx.$store.state.spaces.length * 100) /
										_ctx.$store.state.organization.limitation.organization_spaces
							  ) >= 100
							? 'bg-danger'
							: 'bg-success'
					]),
                      role: "progressbar",
                      style: _normalizeStyle(
						'width:' +
						Number(
							(_ctx.$store.state.spaces.length * 100) /
								_ctx.$store.state.organization.limitation.organization_spaces
						) +
						'%; height: 0.25rem'
					),
                      "aria-valuenow": 
						Number(
							(_ctx.$store.state.spaces.length * 100) /
								_ctx.$store.state.organization.limitation.organization_spaces
						)
					,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 14, _hoisted_106))
                  : (_openBlock(), _createElementBlock("div", _hoisted_107))
            ])
          ]),
          (
				_ctx.$permission.canUpdateOrganizationBilling(_ctx.$store.state.organization.role)
			)
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _createVNode(_component_router_link, {
                  to: {
					name: _ctx.$config('RouteConfig', 'PlansRouteName'),
					params: {
						organization_id: _ctx.$store.state.organization._id,
						space_id: _ctx.$store.state.space._id,
					},
				},
                  class: "btn btn-secondary btn-sm d-block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Plan_Upgrade'))), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}